import * as types from './mutation-types'
import { convertIntToBoolean } from '@/helpers'

let defaultObject = () => ({
  data: {}
})

export default {
  [types.SET_QUIZ] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.quiz = payload
    if (payload.answers) {
      state.quiz.answers = payload.answers.data
    }
  },
  [types.SET_QUIZZES] (state, payload) {
    state.quizzes = []
    if (payload.data.length > 0) {
      for (let quiz of payload.data) {
        convertIntToBoolean(quiz, ['status'])
      }
      state.quizzes = payload.data
    }
    state.pagination = payload.meta.pagination
  }
}
